import { ReactNode } from 'react';

import { ETypographyVariant } from '@core/type';

import { Typography } from './Typography';

export const SmallerTextBox = ({ children }: { children: ReactNode }) =>
  children && (
    <Typography variant={ETypographyVariant.CAPTION1} lineHeight={'1.34'} width={'100%'}>
      {children}
    </Typography>
  );
